<template>
  <v-container class="col-12">
    <v-card class="pa-4">
      <v-row class="mx-0">
        <select-project
          v-model="project"
          :project-list-custom="projectList"
          class="col-1"
          style="min-width: 250px; max-width: 250px"
        />

        <v-btn color="info" v-on:click="search" class="mt-3" :disabled="loading" :loading="loading">Search</v-btn>
        <v-btn color="success" v-on:click="payoutHandler" class="mt-3 ml-5" :disabled="loading" :loading="loading">Payout ({{ selected.filter(o => o.status == 'pending').length }})</v-btn>

        <v-menu>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mt-3 ml-5"
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              :disabled="loading"
              :loading="loading"
            >
              Change status ({{ selected.filter(o => o.status == 'processing').length }})
            </v-btn>
          </template>

          <v-list>
            <v-list-item link>
              <v-list-item-title @click="changeState('complete')">Complete</v-list-item-title>
            </v-list-item>
            <v-list-item link>
              <v-list-item-title @click="changeState('pending')">Pending</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
    </v-card>


    <v-card class="pa-0 mt-4">
      <v-data-table
        v-model="selected"
        show-select
        @toggle-select-all="selectAllFilter"
        :loading="loading"
        :server-items-length="total"
        :headers="headers"
        sort-by="created"
        sort-desc
        :options.sync="options"
        :items="items"
        :expanded.sync="expanded"
        item-key="account_transaction_id"
        :footer-props="{'items-per-page-options': [15, 25, 50, 100, -1]}"
        :items-per-page="25"
        show-expand
        :class="{'payment-handler-dt': true, 'footer-padding': $store.state.auth.checkAccess({key: 'kiosk.access', value: true})}"
        style="z-index: 0; position: relative;"
      >
        <template v-slot:body.prepend>
          <tr class="grey lighten-3">
            <td style="border: none"></td>
            <td
              v-for="header in headers"
              :key="header.text"
              style="border: none"
            >
              <v-select
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
                hide-details
                dense
                small
                multiple
                clearable
                persistent-hint
                return-object
                single-line
                class="data-table-finance-filter-select"
                :items="columnValueList(header.value)"
                v-model="filters[header.value].data"
              />
              <v-text-field
                class="data-table-finance-filter-textfield"
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
                v-model="filters[header.value].data"
                hide-details
              />
            </td>
          </tr>
        </template>

        <template v-slot:item.data-table-select="{ item, isSelected, select }">
          <v-simple-checkbox
            :value="isSelected"
            :readonly="item.status !== 'pending' && item.status !== 'processing'"
            :disabled="item.status !== 'pending' && item.status !== 'processing'"
            :ripple="false"
            @input="select($event)"
          ></v-simple-checkbox>
        </template>

        <template v-slot:expanded-item="{ headers , item }">
          <td :colspan="headers.length">
            <v-row class="col-12 px-5 pb-0 payment-handler-details">

              <v-text-field
                :value="item.account_transaction_id"
                label="ID"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.login"
                label="Login"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.type"
                label="Type"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.status"
                label="Status"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.amount"
                :label="`Amount (${item.currency})`"
                :suffix="item.currency"
                small
                outlined
                readonly
                hide-details
                class="col-1  text-right"
              ></v-text-field>
              <v-text-field
                :value="item.amount_eur"
                label="Amount (EUR)"
                suffix="EUR"
                small
                outlined
                readonly
                hide-details
                class="col-1  text-right"
              ></v-text-field>
              <v-text-field
                :value="item.account"
                label="Account"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.paymethod"
                label="Paymethod"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.paysystem"
                label="Paysystem"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.created"
                label="Created"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.updated"
                label="Updated"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.account_info.profile.name"
                label="Name"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
              <v-text-field
                :value="item.account_info.profile.surname"
                label="Surname"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>

              <v-text-field
                v-for="(param, key) in (item.details.params || {})"
                :key="key"
                :value="param"
                :label="startCase(key)"
                small
                outlined
                readonly
                hide-details
                class="col-2 "
              ></v-text-field>
            </v-row>

            <v-row class="col-12 px-5 pt-0 payment-handler-details">


              <v-textarea
                :value="item.comment"
                label="Comment"
                small
                outlined
                auto-grow
                rows="1"
                readonly
                hide-details
                class="col-12 no-resize"
              ></v-textarea>
            </v-row>

          </td>
        </template>

        <template v-slot:item.account_id="{ item, header }">
          <span style="white-space: nowrap">
            <v-icon :color="item.withdraw_alert ? 'green' : 'red'" :title="'Total withdraws: ' + item.total_withdraw_eur + 'EUR'" small>
              {{ item.withdraw_alert ? 'mdi-arrow-up-bold' : 'mdi-arrow-down-bold' }}
            </v-icon>
            <a :href="'/user-management/' + item.login " target="_blank">{{ item.account_id }}</a>
            <v-icon v-if="item.first_withdraw" class="ml-1" title="First Withdraw" small>mdi-numeric-1-box</v-icon>
          </span>
        </template>

        <template v-slot:item.account="{ item }">
          <div style="max-width: 170px; overflow: hidden; text-overflow: ellipsis" class="nowrap">
            {{ item.account }}
          </div>
        </template>

        <template v-slot:item.created="{ item }">
          <div style="min-width: 135px;">
            {{ item.created }}<br />
            {{ item.updated }}
          </div>
        </template>

        <template v-slot:item.status="{ item }">
          <v-tooltip bottom open-on-click v-if="!item.details.kyc.review">
            <template v-slot:activator="{ on, attrs }">
              <v-select
                :items="statuses"
                v-model="item.status"
                v-bind="attrs"
                v-on="on"
                readonly
                dense
                hide-details
                x-small
                class="mt-0"
                style="max-width: 150px;"
              ></v-select>
            </template>
            <span>Review before you can change status</span>
          </v-tooltip>
          <v-select
            v-else
            :items="statuses"
            v-model="item.status"
            :readonly="!(item.details.kyc.review) || !$store.state.auth.checkAccess({key: 'payment_handler_update', value: true})"
            dense
            hide-details
            x-small
            class="mt-0"
            style="max-width: 150px;"
          ></v-select>
        </template>
        <template v-slot:item.details.kyc.verified="{ item }">
          <v-btn
            small
            :color="item.details.kyc.verified ? 'primary' : 'info'"
            @click="item.details.kyc.verified = !item.details.kyc.verified; updateTransaction(item)"
            :disabled="!$store.state.auth.checkAccess({key: 'payment_handler_update', value: true})"
          >
            Verified
          </v-btn>
        </template>
        <template v-slot:item.withdraw-action="{ item }">

        </template>
        <template v-slot:item.details.kyc.docs_approved="{ item }">
          <v-checkbox
            v-model="item.details.kyc.bills && item.details.kyc.id_card && item.details.kyc.psp && item.details.kyc.selfie"
            hide-details
            readonly
            class="mt-0 pt-0"
          ></v-checkbox>
        </template>
        <template v-slot:item.details.kyc.review="{ item }">
          <v-checkbox
            v-model="item.details.kyc.review"
            hide-details
            class="mt-0 pt-0"
            :readonly="!$store.state.auth.checkAccess({key: 'payment_handler_update', value: true})"
          ></v-checkbox>
        </template>
        <template v-slot:item.details.kyc.session_check="{ item }">
          <v-checkbox
            v-model="item.details.kyc.session_check"
            hide-details
            class="mt-0 pt-0"
            :readonly="!$store.state.auth.checkAccess({key: 'payment_handler_update', value: true})"
          ></v-checkbox>
        </template>
        <template v-slot:item.comment="{ item }">
          <withdraw-comments v-model="item.comment" @updateTransaction="updateTransaction(item)" />
        </template>
      </v-data-table>
    </v-card>

  </v-container>
</template>
<style lang="scss" scoped>
  @import './payment-table.scss';
</style>

<script>

  import { map, cloneDeep, get, set, find, startCase, reduce, isEmpty } from 'lodash'
  import { API } from '@/utils/api'
  import moment from 'moment'
  import WithdrawComments from '@/components/helper/WithdrawComments.vue'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {

    props: [ 'title' ],
    components: {
      SelectProject,
      WithdrawComments
    },
    data: () => ({
      selected: [],
      expanded: [],
      entities: false,
      headers: [
        { text: 'Created / Updated', value: 'created', 'class': 'nowrap' },
        { text: 'TransactionID', value: 'account_transaction_id', sortable: false, 'class': 'nowrap' },
        { text: 'AccountID', value: 'account_id', sortable: false, 'class': 'nowrap' },
        { text: 'Amount', value: 'amount', 'class': 'nowrap' },
        { text: 'Currency', value: 'currency', 'class': 'nowrap' },
        { text: 'In EUR', value: 'amount_eur', 'class': 'nowrap' },
        { text: 'Status', value: 'status', 'class': 'nowrap' },
        { text: 'Account', value: 'account', 'class': 'nowrap' },
        { text: 'Verify', value: 'details.kyc.verified', 'class': 'nowrap', sortable: false, },
        { text: 'Docs', value: 'details.kyc.docs_approved', 'class': 'nowrap', sortable: false, },
        { text: 'Session', value: 'details.kyc.session_check', 'class': 'nowrap', sortable: false, },
        { text: 'Review', value: 'details.kyc.review', 'class': 'nowrap', sortable: false, },
        { text: 'Description', align: 'left', sortable: false, value: 'comment', 'class': 'nowrap' },
        { text: '', value: 'data-table-expand', 'class': 'nowrap' },
      ],
      filters: {
        status: { data: [ 'pending' ], type: 'select' },
        paymethod: { data: [ 'paytah' ], type: 'select' },
        account: { data: [], type: 'text' },
        account_id: { data: [], type: 'text' },
      },
      statuses: [ 'pending', 'complete', 'cancel', 'decline', 'error', 'processing', ],
      project: null,
      loading: false,
      payoutInProgress: false,
      payoutDialog: {
        loadingAccount: false,
        show: false,
        data: {
          account: '',
          fields: {},
          transaction: {},
          withdraw_tokens: [],
        }
      },
      items: [],
      itemsInit: [],
      options: {},
      total: 0,
    }),

    computed: {
      projectList: function () {
        return this.entities || map(this.$store.state.auth.entities, (i) => ({ text: i.name, value: i.entity_id }))
      }
    },

    mounted () {
      this.project = this.projectList[0].value
      this.loadEntities().then((r) => {
        this.project = this.projectList[0].value
      })
    },

    watch: {
      project () {
        if (this.options.page != 1) {
          this.options.page = 1
        } else {
          this.search()
        }
      },
      options: {
        handler () {
          this.search()
        },
      }
    },

    methods: {

      startCase: (k) => startCase(k),

      selectAllFilter (v, k) {
        let selected = v.items.filter(r => (this.filters.status.data.includes(r.status) || this.filters.status.data.length == 0))

        if (this.selected.length == selected.length) {
          this.selected = []
        } else {
          this.selected = selected
        }
      },

      loadEntities () {
        return API.call('/users/entity_list.json').then(resp => {
          this.entities = resp.data
          return resp.data
        }).catch(e => {
        })
      },

      updateTransaction: async function (item) {
        if (!this.$store.state.auth.checkAccess({ key: 'payment_handler_update', value: true })) {
          return
        }
        if (await this.$root.$confirm('Confirm', 'Do you want save changes?')) {

          let fields = [ 'details.kyc.verified', 'details.kyc.docs_approved', 'details.kyc.session_check', 'details.kyc.review' ]
          let params = {}

          for (let k of fields) {
            if (get(item, k) != get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), k)) {
              params[k] = get(item, k)
            }
          }

          API.call('/$v/payment_handler/update.json', {
            account_transaction_id: item.account_transaction_id,
            status: get(item, 'status') != get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'status') ? item.status : undefined,
            comment: item.comment,
            fields: params
          }, null, this.project || this.project.value).then(resp => {

            if (resp.data.status == item.status || resp.data.comment == item.comment) {
              if (resp.data.comment == item.comment) {
                set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'comment', item.comment)
              }
              if (resp.data.status == item.status) {
                set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'status', item.status)
              }
            } else {

              this.$nextTick(function () {
                if (resp.data['comment']) {
                  set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'comment', resp.data['comment'])
                  item.comment = resp.data.comment
                }
                if (resp.data['status']) {
                  set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'status', resp.data['status'])
                  item.status = resp.data.status
                }
              })

            }

            this.$notification.show = true
            this.$notification.message = 'Transaction updated'
            this.$notification.type = 'success'

            return resp.data
          }).catch(e => {
            this.search()
          })
        } else {
          this.$nextTick(function () {
            item.comment = get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'comment')
            item.status = get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'status')
          })
        }
      },

      payoutHandler: function () {
        this.loading = true

        API.call('/$v/payment_handler/payout_paytah.json', {
          data: this.selected,
        }, null, this.project || this.project.value, {
          responseType: 'arraybuffer',
          headers: {
            'Accept': 'text/csv'
          }
        }).then(r => this.downloadString(r, 'text/csv', 'paytah_payout_' + moment().format() + '.csv')).finally(() => {
          this.selected = []
          this.loading = false

          return this.search()
        })
      },

      changeState: async function (status) {
        if (await this.$root.$confirm('Confirm', `Update status from processing to ${status}`)) {
          this.loading = true

          API.call('/$v/payment_handler/mass_status_update.json', {
            data: this.selected,
            new_status: status
          }, null, this.project || this.project.value).finally(() => {
            this.selected = []
            this.loading = false

            return this.search()
          })
        }
      },

      downloadString (text, fileType, fileName) {
        let blob = new Blob([ text ], { type: fileType })

        let a = document.createElement('a')
        a.download = fileName
        a.href = URL.createObjectURL(blob)
        a.dataset.downloadurl = [ fileType, a.download, a.href ].join(':')
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        setTimeout(function () {
          URL.revokeObjectURL(a.href)
        }, 1500)
      },
      search: function () {
        this.loading = true

        API.call('/$v/payment_handler/list.json', {
          from: this.from,
          to: this.to,
          type: 'withdraw',
          options: this.options,
          only_selected: true,
          filters: reduce(this.filters, (r, f, k) => {
            if (!isEmpty(f.data)) {
              r[k] = f.data
            }
            return r
          }, {}),
          limit: 50
        }, null, this.project).then(resp => {

          this.total = resp.total
          this.items = cloneDeep(resp.data)
          this.itemsInit = cloneDeep(resp.data)

          return resp.data
        }).catch(e => {
        }).finally(() => {
          this.selected = []
          this.loading = false
        })

      },

      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      columnValueList (val) {
        if (val == 'status') {
          return this.statuses
        }
        return this.items.map(d => d[val])
      }
    },
  }
</script>
